import React, {useEffect, useState} from 'react';
import {
    Box,
    Typography,
    Paper,
    Link,
    Button,
    Avatar
} from '@mui/material';
import VenueList from '../VenueList.tsx';
import {Crumbs} from "../Crumbs.jsx";
import {InTownURI} from "../Button/InTownButton.jsx";
import {Helmet} from "react-helmet";
import {OutOfTownURI} from "../Button/OutOfTownButton.jsx";

const title = "All 2-Step our community has found while traveling";
const desc = "Help us build the list of places to 2-step";
const BACKEND_HOST = process.env["REACT_APP_BACKEND_HOST"];

const VenueOutOfTownPage = () => {
    const [venues, setVenues] = useState([]);

    useEffect(() => {
        let allVenues = [];
        let page = 1;
        let totalPages = 1;

        const fetchVenues = async () => {
            do {
                const res = await fetch(`${BACKEND_HOST}/venues?filters[market][$eq]=remote&pagination[page]=${page}&pagination[pageSize]=100&sort[name]=asc`);
                const data = await res.json();
                allVenues = allVenues.concat(data.data || []);
                totalPages = data.meta?.pagination?.pageCount || 1;
                page++;
            } while (page <= totalPages);

            setVenues(allVenues);
        };

        fetchVenues();
    }, []);

    return (
        <Box>
            <Helmet>
                <meta charSet="utf-8"/>
                <meta property="og:description" content={desc}/>
                <meta property="twitter:title" content={title}/>
                <meta property="twitter:description" content={desc}/>
                <title>{title}</title>
                <meta property="description" content={desc} />
                <link rel="canonical" href={OutOfTownURI}/>
            </Helmet>
            <Crumbs crumbs={
                [
                    {title: "Where To Dance", href: "/where-to-dance"},
                    {title: "Out of Town"}
                ]} />

            {/* Page header */}
            
            <Box p={2} bgcolor={"background.paper"} borderRadius={1} style={{display: 'flex', alignItems: 'center', marginBottom: 16}}>
                <Avatar style={{ float:"left", marginRight: 8 }} alt="Community Member" src="/images/ellie.jpeg" />
                <Typography variant="caption" color="textSecondary" gutterBottom>
                    This community page is curated by Ellie.
                </Typography>
            </Box>

            <Paper>
                <Box m={2} py={2}>
                    All venues are suggestions from the community, including Ellie's Destination Honky Tonks List! 

                </Box>
                <Box m={2}>
                    Found a great venue? Share it here!
                </Box>
                <Box m={2} pb={2}>
                    <Button href={"/venue/edit/new"} variant={"contained"} size={"small"}>Add Venue</Button>
                </Box>
                <Box m={2} pb={2}>
                    Also see all of the venues <Link href={InTownURI} variant={"contained"} size={"small"}>in & near town</Link>.
                </Box>

            </Paper>
            {/* Venue list component */}
            <Box>
                <VenueList showCityState={true} venues={venues} showStateFilter={true} />
            </Box>
        </Box>
    );
};

export default VenueOutOfTownPage;